export default function RevenueIcon({ size }: { size?: number }) {
  return (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <mask
        id='mask0_11648_3072'
        style={{ maskType: 'alpha' }}
        maskUnits='userSpaceOnUse'
        x='0'
        y='0'
        width={size ?? 24}
        height={size ?? 24}
      >
        <rect width='24' height='24' fill='#D9D9D9' />
      </mask>
      <g mask='url(#mask0_11648_3072)'>
        <path
          d='M8.3457 12.9577V6.34619H10.6532V12.9577L9.49945 11.8459L8.3457 12.9577ZM13.0187 14.8229V2.34619H15.3262V12.5154L13.0187 14.8229ZM3.65345 17.6192V10.3462H5.96095V15.3114L3.65345 17.6192ZM3.5957 20.7999L9.4687 14.9269L13.0187 17.9769L19.1957 11.7999H17.2495V10.2999H21.7495V14.7999H20.2495V12.8537L13.0802 20.0229L9.5302 16.9729L5.7032 20.7999H3.5957Z'
          fill='currentColor'
        />
      </g>
    </svg>
  );
}
